import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  heading: {
    fontWeight: "bold",
  },
});
